module.exports = __webpack_public_path__ + "img/6c489d6afef44587a735f7dca0776560.b45fe295.jpg";